import { render, staticRenderFns } from "./classification-header.vue?vue&type=template&id=79b328a2&"
import script from "./classification-header.vue?vue&type=script&lang=js&"
export * from "./classification-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports